/**
 * Selects the in-season value of the option it sits in, checking the month in store time
 * so a page cached before the changeover still switches.
 */
class SeasonalOption extends HTMLElement {
  async connectedCallback() {
    await customElements.whenDefined('variant-picker');

    const value = this.dataset.months?.split(',')[this.#storeMonth()];
    const option = this.closest('.variant-option');
    if (!value || !option) return;

    const select = option.querySelector('select');
    if (select) {
      if (select.value === value) return;
      select.value = value;
      select.dispatchEvent(new Event('change', { bubbles: true }));
      return;
    }

    const radio = Array.from(option.querySelectorAll('input[type="radio"]')).find((input) => input.value === value);
    if (!radio || radio.checked) return;
    radio.checked = true;
    radio.dispatchEvent(new Event('change', { bubbles: true }));
  }

  /** @returns {number} Month index (0-11) in the store's time zone */
  #storeMonth() {
    const match = /^([+-])(\d{2})(\d{2})$/.exec(this.dataset.utcOffset ?? '');
    if (!match) return new Date().getMonth();

    const [, sign, hours, minutes] = match;
    const offsetMinutes = (sign === '-' ? -1 : 1) * (Number(hours) * 60 + Number(minutes));
    return new Date(Date.now() + offsetMinutes * 60000).getUTCMonth();
  }
}

if (!customElements.get('seasonal-option')) {
  customElements.define('seasonal-option', SeasonalOption);
}
